import React from 'react';
import { Link } from 'react-router-dom';
export default function NotFound() {
  return <main className="erp-empty"><h1>Page not found</h1><p>The address may have changed. Open your workspace to continue.</p><Link className="erp-button" to="/">Open workspace</Link></main>;
}
